/* eslint-disable camelcase */

export enum WorksheetAs {
  Object = "Object", // for key: value pairs
  Table = "Table", // for rows of data
}

export type WorksheetBaseType = {
  id: string;
  version: string;
};

// These types are taken directly from the back-end structs
export interface WorksheetUpdate {
  name: string;
  value: string;
  action?: string;
  index?: number;
}

export interface WorksheetValuesRequest {
  application_id: number;
  version: string;
  updates: WorksheetUpdate[];
}

export interface WorksheetDeleteUpdate {
  name: string;
  action: "delete";
  index?: number;
}

export interface WorksheetValuesDeleteRequest {
  version: string;
  updates: WorksheetDeleteUpdate[];
}
